import React from 'react';
import { connect } from 'react-redux';
import { withStyles, Typography, Card, CardContent, CardActions, IconButton, Toolbar, Button, Modal } from '@material-ui/core';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import Select from 'react-select';
import { getUsersProjectTitles, getAllRelatedDocuments, prepareFilters, getUsersProjects } from '../../firebase/db/project';
import { updateDocumentDescription, removeTag, updateDocumentTags } from '../../firebase/db';
import { getAllInvolvedUsers } from '../../firebase/db/tasks';
import classNames from 'classnames';
import Icon from '@material-ui/core/Icon';
import { downloadDocURL } from '../../firebase/storage';
import { downloadDoc } from '../../firebase/functions';
import saveAs from 'file-saver';
import SearchBar from 'material-ui-search-bar';
import validator from 'validator';
import LoadingProgress from '../common/LoadingProgress';
import _ from 'lodash';
import DocumentTags from '../common/DocumentTags';
import { toast } from 'react-toastify';

const styles = theme => ({
    filter: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
    },
    container: {
        margin: '3% 10% 0'
    },
    docContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        flexDirection: 'row',
    },
    select: {
        minWidth: '200px',
        marginRight: '10px',
        borderRadius: 0,
        fontFamily: '-apple-system,system-ui,BlinkMacSystemFont,' + "'Roboto', sans-serif",
    },
    textName: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        fontSize: 14,
        width: 130
    },
    actions: {
        display: 'flex',
        flexDirection: 'row-reverse'
    },
    cardContent: {
        display: 'flex',
        flexDirection: 'column',
        paddingLeft: 25
    },
    search: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45%',
        height: 40,
        borderRadius: '25px'
    },
});
class Documents extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            projects: [],
            cycles: [],
            tasks: [],
            authors: [],
            types: [{ label: 'jpg', value: 'jpg' },
            { label: 'png', value: 'png' },
            { label: 'tiff', value: 'tiff' },
            { label: 'pdf', value: 'pdf' },
            { label: 'docx', value: 'docx' },
            { label: 'doc', value: 'doc' },
            { label: 'odt', value: 'odt' },
            { label: 'csv', value: 'csv' },
            { label: 'xls', value: 'xls' },
            { label: 'xslx', value: 'xslx' },
            { label: 'zip', value: 'zip' },
            ],
            allDocuments: {},
            filteredDocuments: {},
            userRoles: [],
            loading: true,
            downloading: false
        };
    }

    componentDidMount() {
        const { props: { auth } } = this;
        getAllInvolvedUsers(auth.email)
            .then((users) => {
                let uniqueUserRoles = _.uniqWith(users, _.isEqual)
                this.setState({
                    userRoles: uniqueUserRoles
                })
            })
        this.documentCall();
        getUsersProjectTitles(auth.email)
            .then((projectTitles) => {
                let titles = projectTitles.reduce((acc, proj) => Object.assign(acc, proj), {});
                this.setState({
                    titles
                })
            })
    }

    documentCall = () => {
        const { props: { auth } } = this;
        getAllRelatedDocuments(auth.email)
            .then((documents) => {
                let assigned = Object.keys(documents).map((doc) => {
                    return Object.assign(documents[doc], { 'id': doc });
                })
                this.setState({ allDocuments: assigned, filteredDocuments: assigned, forTags: documents }, () => {
                    prepareFilters(this.state.filteredDocuments)
                        .then(filters => {
                            const [projects, cycles, tasks, authors, types] = filters;
                            this.setState({ projects, cycles: cycles.filter(c => c), tasks, authors, types, loading: false });
                        });
                });
            })
    }

    handleChange = name => selected => {
        this.setState({ [name]: selected && selected.value }, () => {
            const { allDocuments, projectId, cycleId, taskId, userId, fileType, searchValue } = this.state;
            const filteredDocuments = Object.keys(allDocuments)
                .filter(docId => {
                    const document = allDocuments[docId];
                    let isVisible = true;
                    let isSearched = true;
                    if (projectId) {
                        isVisible = document.project === projectId;
                    }
                    if (cycleId) {
                        isVisible = isVisible && (document.cycle === cycleId);
                    }
                    if (taskId) {
                        isVisible = isVisible && (document.task === taskId);
                    }
                    if (userId) {
                        isVisible = isVisible && (document.user === userId);
                    }
                    if (fileType) {
                        isVisible = isVisible && (document.name.split('.').pop() === fileType);
                    }
                    if (searchValue) {
                        isSearched = (document.tags && Object.keys(document.tags).some((element) => {
                            if (validator.isEmail(searchValue)) {
                                return validator.isBase64(element) && window.atob(element) === searchValue;
                            }
                            return element.toLowerCase().includes(searchValue.toLowerCase());
                        })) // || (document.project && document.project.toLowerCase().includes(searchValue.toLowerCase()))
                            // || (document.cycle && document.cycle.toLowerCase().includes(searchValue.toLowerCase()))
                            // || (document.task && document.task.toLowerCase().includes(searchValue.toLowerCase()))
                            || (document.user && validator.isBase64(document.user) && window.atob(document.user).toLowerCase().includes(searchValue.toLowerCase()))
                            || (document.name && document.name.split('.').pop().toLowerCase().includes(searchValue.toLowerCase()))
                            || (document.name && document.name.toLowerCase().includes(searchValue.toLowerCase()))
                    }
                    return isVisible && isSearched;
                })
                .reduce((result, docId) => {
                    result[docId] = Object.assign({}, allDocuments[docId]);
                    return result;
                }, {});
            if (Object.keys(filteredDocuments).length > 0) {
                this.setState({ filteredDocuments }, () => prepareFilters(this.state.filteredDocuments)
                    .then(filters => {
                        const [projects, cycles, tasks, authors] = filters;
                        this.setState({ projects, cycles, tasks, authors });
                    }));
            } else {
                toast.error("Kein passendes Dokument gefunden!", {
                    position: "top-center",
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                });
            }
        });
    };

    downloadDocument = (filename, filePath) => {
        this.setState({ downloading: true });
        downloadDoc(filename, filePath)
            .then((response) => {
                this.setState({ downloading: false });
                saveAs(new Blob([response.data]), filename);
            })
            .catch((err) => {
                this.setState({ downloading: false });
                console.log(err);
            });
    }

    showDescription = (key) => {
        const { forTags } = this.state;
        if (forTags[key].hasOwnProperty('tags') === false) {
            forTags[key]['tags'] = []
        }
        this.setState({ popup: !this.state.popup, index: key })
    }

    sendTags = (tags) => {
        const { forTags, index } = this.state
        if (Array.isArray(forTags[index]['tags'])) {
            let diff = _.difference(forTags[index]['tags'], tags);
            diff.map((tag) => {
                removeTag(index, tag);
            })
        } else {
            let diff2 = _.difference(Object.keys(forTags[index]['tags']), tags);
            diff2.map((tag) => {
                removeTag(index, tag);
            })
        }
        this.setState((state) => {
            const property = state.forTags;
            property[index]['tags'] = tags;
            return { ...state, property };
        }, function () {
            if (Array.isArray(forTags[index].tags)) {
                forTags[index].tags.forEach((tag) => {
                    updateDocumentTags(index, tag);
                })
            } else {
                Object.keys(forTags[index].tags).map((key) => {
                    return updateDocumentTags(index, key)
                })
            }
            this.documentCall();
        })
    }

    handleTextFieldChange = (propertyName, field, value) => {
        const { index } = this.state
        this.setState((state) => {
            const property = state[propertyName];
            property[index][field] = value;
            return { ...state, property };
        });
    };

    onCloseDescription = () => {
        this.setState({ popup: false, index: null })
    }

    onCancelDialog = () => {
        this.setState({ popup: false });
    }

    isDisabled = (document) => {
        const { props: { auth } } = this;
        const { userRoles } = this.state;
        if (userRoles.length > 0) {
            return userRoles.some((member) => {
                if (Object.values(member)[0][0] === 'manager' || window.atob(document.user) === auth.email) {
                    return true;
                } else {
                    return false;
                }
            })
        }
        else {
            if (auth.email === window.atob(document.user)) {
                return true;
            } else {
                return false;
            }
        }
    }

    render() {
        const { classes } = this.props;
        const { projectId, cycleId, taskId, userId, titles, forTags, fileType, projects, cycles, tasks, authors, types, filteredDocuments, loading, downloading } = this.state;
        let documentsRendered = () => {
            let mapped = _.groupBy(Object.values(filteredDocuments), 'project');
            return Object.keys(mapped).map((doc, i) => {
                return (
                    <div key={i}>
                        <Typography variant="title">{titles[doc]}</Typography>
                        <div className={classes.docContainer}>
                            {
                                Object.values(mapped[doc]).map((document) => {
                                    let iconName = 'file';
                                    switch (document.name.split('.').pop().toLowerCase()) {
                                        case 'jpg': case 'jpeg': case 'bpm': case 'tiff': case 'gif': case 'png': case 'svg':
                                            iconName = 'file-image';
                                            break;
                                        case 'pdf':
                                            iconName = 'file-pdf';
                                            break;
                                        case 'zip':
                                            iconName = 'file-archive';
                                            break;
                                        case 'doc': case 'docx': case 'odt':
                                            iconName = 'file-word';
                                            break;
                                        case 'xls': case 'xlsx': case 'csv':
                                            iconName = 'file-excel';
                                            break;
                                    }
                                    return (<Card style={{
                                        margin: 15,
                                        width: 150,
                                        height: 150,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'flex-start',
                                        alignContent: 'flex-start'
                                    }}>
                                        <CardContent className={classes.cardContent}>
                                            <Icon
                                                className={classNames(classes.icon, `fa fa-${iconName}`)}
                                                color="primary"
                                                fontSize="large"
                                            />
                                            <Typography className={classes.textName} >
                                                {document.name}
                                            </Typography>
                                            <Typography className={classes.textName} >
                                                {'Upload' + ': ' + (new Date(document.uploadDate)).toLocaleDateString('de-AT')}
                                            </Typography>
                                        </CardContent>
                                        <CardActions style={{ position: 'relative', backgroundColor: '#c5c2c2', height: '40px', width: '150px', display: 'flex', flexDirection: 'row', top: '3px', alignItems: 'center', justifyContent: 'flex-end' }} disableActionSpacing>
                                            {this.isDisabled(document) &&
                                                <Button
                                                    color="primary"
                                                    onClick={() => this.showDescription(document.id)}
                                                >
                                                    <img src={require('../../icons/ribbon.svg')} height="20" width="20" />
                                                </Button>
                                            }
                                            < IconButton
                                                aria-label="Download document"
                                                onClick={() => this.downloadDocument(document.name, `documents/${document.id}/${document.name}`)}>
                                                <DownloadIcon />
                                            </IconButton>
                                        </CardActions>
                                    </Card>)
                                })
                            }
                        </div>
                    </div>
                )
            })
        }
        if (loading === true) {
            return <LoadingProgress />
        }
        return (
            <div className={classes.container}>
                {downloading && <Modal open={downloading}><LoadingProgress /></Modal>}
                <div className={classes.filter}>
                    <div className={classes.filter}>
                        <Select
                            isClearable
                            isMulti={false}
                            onChange={this.handleChange('projectId')}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Projekt'
                            options={projects}
                        />
                        <Select
                            isClearable
                            isMulti={false}
                            onChange={this.handleChange('cycleId')}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Cycle'
                            options={cycles}
                        />
                        <Select
                            isClearable
                            isMulti={false}
                            onChange={this.handleChange('taskId')}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Task'
                            options={tasks}
                        />
                        <Select
                            isClearable
                            isMulti={false}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Autor'
                            options={authors}
                            onChange={this.handleChange('userId')}
                        />
                        <Select
                            isClearable
                            isMulti={false}
                            onChange={this.handleChange('fileType')}
                            closeMenuOnSelect={false}
                            className={classes.select}
                            placeholder='Typ'
                            options={types}
                        />
                    </div>
                    <Typography
                        variant="body2"
                        color="secondary"
                    >
                        {`${Object.keys(filteredDocuments).length} Dokumente`}
                    </Typography>
                </div>
                <Toolbar className={classes.filter}>
                    <SearchBar
                        className={classes.search}
                        placeholder={'Such nach Dokumenten und Tags'}
                        cancelOnEscape={true}
                        onChange={(searchValue) => !searchValue && this.handleChange('searchValue')({ value: '' })}
                        onRequestSearch={(searchValue) => this.handleChange('searchValue')({ value: searchValue })}
                        onCancelSearch={() => this.handleChange('searchValue')({ value: '' })}
                    />
                </Toolbar>
                {documentsRendered()}
                {
                    this.state.popup &&
                    <DocumentTags
                        visible={this.state.popup}
                        tags={forTags[this.state.index].tags}
                        description={forTags[this.state.index].description}
                        onCancel={this.onCancelDialog}
                        onTagsChange={(tags) => this.sendTags(tags)}
                        onDescriptionChange={(e) => this.handleTextFieldChange('forTags', 'description', e.target.value)}
                        onDescriptionBlur={(e) => updateDocumentDescription(this.state.index, e.target.value)}
                        onConfirm={this.onCloseDescription} />
                }
            </div>
        );
    }
}


export default withStyles(styles)(connect(state => ({
    auth: state.firebase.auth,
}))(Documents));



// WEBPACK FOOTER //
// ./src/components/Documents/Documents.js